import styled from 'styled-components';

import { Media } from '@/js/libs/ui';
import {
  COLLAPSING_TRANSITION,
  SPACER_DEFAULT,
  NAVIGATION_WIDTH,
  NAVIGATION_WIDTH_COLLAPSED,
  ITEMS_LIST_PADDING,
} from '@/js/libs/ui/src/V2/Components/PuzzleNav/constants';
import { BUTTON_SIZE_DEFAULT_PX } from '@/js/libs/ui/src/V2/Controls/Button/constants';

const FOOTER_DEFAULT_SPACER_VALUE = 6;
const FOOTER_DEFAULT_SPACER = `${FOOTER_DEFAULT_SPACER_VALUE}px`;
export const STATUS_ICON_SIZE_VALUE = FOOTER_DEFAULT_SPACER_VALUE * 2;
export const STATUS_ICON_SIZE = `${STATUS_ICON_SIZE_VALUE}px`;

export const Wrapper = styled.div<{ isCollapsedNav: boolean }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.grey01_1};
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.grey10_1};
    @media ${Media.lgMin} {
      width: ${({ isCollapsedNav }) => (isCollapsedNav ? `calc(100% - ${SPACER_DEFAULT})` : '100%')};
      transition: width ${COLLAPSING_TRANSITION};
    }
  }
`;

export const Label = styled.span<{ $nowrap?: boolean }>`
  ${({ theme }) => theme.typography.textExtraSmall};
  white-space: ${({ $nowrap }) => $nowrap && 'nowrap'};
  &&& {
    color: ${({ theme }) => theme.colors.grey100_1};
  }
`;

export const StatusLink = styled.a<{ isCollapsedNav: boolean }>`
  display: flex;
  gap: ${FOOTER_DEFAULT_SPACER};
  align-items: center;
  min-height: calc(${BUTTON_SIZE_DEFAULT_PX} + (${FOOTER_DEFAULT_SPACER} * 2));
  min-width: ${({ isCollapsedNav }) =>
    !isCollapsedNav && `calc(${NAVIGATION_WIDTH} - ((${BUTTON_SIZE_DEFAULT_PX} * 2) + (${FOOTER_DEFAULT_SPACER} * 4)))`};
  padding: 0
    ${({ isCollapsedNav }) => (isCollapsedNav ? `calc((${NAVIGATION_WIDTH_COLLAPSED} - ${STATUS_ICON_SIZE}) / 2)` : ITEMS_LIST_PADDING)};
  transition: padding ${COLLAPSING_TRANSITION};
`;

export const LanguageTitle = styled.span`
  text-transform: uppercase;
`;

export const ActionGroup = styled.div`
  display: flex;
`;

export const ActionGroupItem = styled.div`
  padding: ${FOOTER_DEFAULT_SPACER};
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 1px;
    background-color: ${({ theme }) => theme.colors.grey10_1};
  }
`;
